import styled from "styled-components";
import React from 'react'
const Container = styled.div`
  height: 30px;
  background-color: teal;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Noto Serif TC', serif;
  border-bottom: 1px solid lightgray;
`;


const Announcement = () => {
  return (
    <>
      <Container>限時特賣！全品項打八折！這為電商平台測試version1</Container>
   </>
  )
}

export default Announcement;
